/**
 * PLP card swatch painter.
 *
 * Each swatch dot in `snippets/card-product-swatches.liquid` is rendered with
 * a `data-swatch-colour="<Colour Name>"` attribute. This script reads
 * `window.colours[colourName]` (the global swatch dictionary populated
 * elsewhere in the theme) and paints the dot — either a solid hex
 * background, or a pattern image, plus a soft shadow ring for very
 * light colours so they're visible against a white card.
 *
 * Why a separate asset instead of an inline `<script>` per swatch?
 * The collection page uses Ajaxinate (`assets/ajaxinate.min.js`) for the
 * "Load more" pagination, which fetches HTML and inserts it via
 * innerHTML. Inline `<script>` tags inserted that way DO NOT execute in
 * modern browsers — so the swatch dots on every page after the first
 * stayed transparent. Moving the paint logic into a callable function
 * lets the Ajaxinate callback re-run it after each load.
 *
 * Idempotent: each painted swatch gets `data-swatch-painted` so repeat
 * calls are cheap no-ops.
 */
(function () {
  function paintOne(el) {
    if (!el || el.hasAttribute('data-swatch-painted')) return;
    var name = el.getAttribute('data-swatch-colour');
    var data = window.colours && name && window.colours[name];
    if (!data) return;
    if (data.type === 'colour' && data.hex) {
      el.style.background = data.hex;
      var hex = data.hex.trim();
      var r = parseInt(hex.substr(1, 2), 16);
      var g = parseInt(hex.substr(3, 2), 16);
      var b = parseInt(hex.substr(5, 2), 16);
      if (r >= 230 && g >= 230 && b >= 230) {
        el.classList.add('card-swatches__swatch--shadow');
      }
    } else if (data.type === 'pattern' && data.image) {
      el.style.backgroundImage = 'url(' + data.image + ')';
    } else {
      return; // unknown shape — leave unmarked so it'll retry next call
    }
    el.setAttribute('data-swatch-painted', '');
  }

  function paintAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.card-swatches__swatch[data-swatch-colour]:not([data-swatch-painted])');
    for (var i = 0; i < els.length; i++) paintOne(els[i]);
  }

  // Expose so other scripts (e.g. the Ajaxinate callback in
  // sections/main-collection-product-grid.liquid) can re-paint after
  // injecting new product cards into the page.
  window.paintCardSwatches = paintAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paintAll(document); });
  } else {
    paintAll(document);
  }
})();
